import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "ai-chat-header" };
const _hoisted_2 = {
    key: 0,
    class: "ai-chat-scroll"
};
const _hoisted_3 = {
    key: 1,
    class: "ai-chat-text"
};
import { ref, computed, onMounted, onUnmounted } from 'vue';
import { useRoute } from 'vue-router';
import ChatMgButton from '@/components/elements/ChatMgButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AiChatBanner',
    props: {
        examples: { default: undefined },
        prompts: { default: undefined },
        dynamicSuggestions: { type: Boolean, default: false },
        context: { default: '' },
        prefill: { type: Boolean, default: false }
    },
    setup(__props, { expose: __expose }) {
        const route = useRoute();
        // ponytail: prompts/context/dynamicSuggestions kept so callers don't change; the
        // drawer has no suggestion chips, so only the rotating example text uses them.
        const props = __props;
        const resolvedExamples = computed(() => {
            return props.prompts ?? props.examples ?? route.meta.aiExamples;
        });
        const currentIndex = ref(0);
        // Wrapped so a shorter prompt list (e.g. after a tab change) never points past the end.
        const currentExample = computed(() => {
            const list = resolvedExamples.value || [];
            return list.length ? list[currentIndex.value % list.length] : '';
        });
        let intervalId = null;
        const chatRef = ref(null);
        // A caller can pass its own question to type in, e.g. the tax code card's "Ask about my tax code".
        function openChat(text) {
            chatRef.value?.toggleDrawer(text ?? (props.prefill ? currentExample.value : undefined));
        }
        __expose({ openChat });
        // Always ticking, so prompts that arrive or grow after mount still rotate.
        onMounted(() => {
            intervalId = setInterval(() => {
                const length = resolvedExamples.value?.length || 0;
                if (length > 1)
                    currentIndex.value = (currentIndex.value + 1) % length;
            }, 3000);
        });
        onUnmounted(() => {
            if (intervalId)
                clearInterval(intervalId);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "ai-chat-banner",
                onClick: _cache[0] || (_cache[0] = ($event) => (openChat()))
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(ChatMgButton, {
                        ref_key: "chatRef",
                        ref: chatRef,
                        hover: false,
                        size: "24",
                        class: "ai-chat-icon"
                    }, null, 512),
                    (resolvedExamples.value && resolvedExamples.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createVNode(_Transition, {
                                name: "scroll-text",
                                mode: "out-in"
                            }, {
                                default: _withCtx(() => [
                                    (_openBlock(), _createElementBlock("span", {
                                        class: "ai-chat-text",
                                        key: currentIndex.value
                                    }, _toDisplayString(currentExample.value), 1))
                                ]),
                                _: 1
                            })
                        ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_3, "Ask your assistant..."))
                ])
            ]));
        };
    }
});
